import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { DataService } from 'src/app/services/data.service';
import { IActivity, IVocabulary } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService, pushObjArray } from 'src/app/services/convert.service';
import { COLLECTION_NAME, FILE_FOLDER } from 'src/app/dummy/app';
import { Observable } from 'rxjs';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-dictation',
  templateUrl: './add-dictation.component.html',
  styleUrls: ['./add-dictation.component.scss']
})
export class AddDictationComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  @ViewChild('soundFile', { static: false }) soundFile: ElementRef;

  TITLE = "Create new dictation"

  form: FormGroup;
  word: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  SELECTED_SOUND_FILE: any;
  uploadPercent: Observable<number>
  START_UPLOAD: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddDictationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: ActivityStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private storage: FireStorageService,
    private route: Router,
  ) { }

  ngOnInit() {
    const { QUESTION } = this.data;
    this.form = this.fb.group({
      word: [QUESTION ? QUESTION.word : null, Validators.compose([Validators.required])],
    })
    if (QUESTION) {
      this.TITLE = "Edit dictation";
    }
  }


  async uploadFileSound(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_SOUND_FILE = event.target.files[0];
      this.soundFile.nativeElement.value = "";
    }
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    const { FORM, SKILL, ACTIVITY_TYPE, MODULE_KEY, ITEM, QUESTION, ACTIVITY_TYPE_OBJECT, SKILL_NAME } = this.data;
    if (!this.SELECTED_SOUND_FILE && !QUESTION) {
      alert('Please select sound file');
      return;
    }
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { word } = f;
      const key = ITEM ? ITEM.key : this.ds.createId();
      const { name, instruction, defaultInstruction } = FORM;
      const { user, selectedCompanyKey } = this.auth;
      const wordKey = QUESTION ? QUESTION.key : this.ds.createId();

      const words = ITEM ? ITEM.words : [];
      const registerStatus = STATUS_OBJECT.submitted;
      const activity: IActivity = {
        key: key,
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name || null,
        instruction: instruction || null,
        defaultInstruction: defaultInstruction || false,
        words: words,
        hasSubActivity: true,
        //module
        skillKey: SKILL,
        skillRef: this.ds.skillRef().doc(SKILL).ref,
        skillName: SKILL_NAME,
        activityTypeKey: ACTIVITY_TYPE,
        activityTypeRef: this.ds.activityTypeRef().doc(ACTIVITY_TYPE).ref,
        activityTypeName: ACTIVITY_TYPE_OBJECT.name,
        moduleKey: MODULE_KEY,
        moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(MODULE_KEY).ref,
      }

      let wordData: any = {
        word: `${word}`.trim(),
        key: wordKey,
        soundDownloadURL: QUESTION ? QUESTION.soundDownloadURL : null,
        soundFile: QUESTION ? QUESTION.soundFile : null,
      };

      if (this.SELECTED_SOUND_FILE) {
        this.START_UPLOAD = true;
        const file = this.SELECTED_SOUND_FILE;
        const fileName = file.name;
        const uploadPath = `${FILE_FOLDER.TRAINING_RESOURCES}/${this.ds.createId()}_${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
        wordData = {
          word: `${word}`.trim(),
          key: wordKey,
          soundDownloadURL: files.downloadUrl,
          soundFile: files,
        };
      }
      const WORDS_DATA = pushObjArray(words || [], wordData)
      activity.words = WORDS_DATA;

      this.store.addItem(activity, this.data.MODULE, true, (success, res) => {
        this.data.ITEM = activity;
        this.snackBar.open("Dictation has been saved successful.", "Done", { duration: 1000 });
        if (ITEM) {
          this.dialogRef.close('no')
          return;
        }
        if (!isNew) {
          this.route.navigate([`/modules/activity-type/${ACTIVITY_TYPE}/${SKILL}/${MODULE_KEY}/${activity.key}`])
          this.dialogRef.close('no')
          return;
        }
        this.form.reset();
        this.form.enable();
        this.form.patchValue({ isFill: false })
        this.processNew = false;
        this.processClose = false;
        this.SELECTED_SOUND_FILE = null;
        this.START_UPLOAD = false;
        this.isCreate = false;
        this.inputEl.nativeElement.focus()
        this.route.navigate([`/modules/activity-type/${ACTIVITY_TYPE}/${SKILL}/${MODULE_KEY}/${activity.key}`])
      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}